import { combineReducers } from 'redux';

import notificationFlag from './notificationFlag';

export default combineReducers({
  notificationFlag,
});

export type MetaModuleState = {
  notificationFlag: any[];
};
